<template>
  <el-form class="serach-form" inline :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.examInfoStatus"
        placeholder="考试状态"
      >
        <el-option
          v-for="(item, i) in examInfoStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.examInfoType"
        placeholder="考试类型"
      >
        <el-option
          v-for="(item, i) in examInfoTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="试卷/班级名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      examInfoStatusData: [],
      examInfoTypeData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["EXAM_INFO_STATUS", "EXAM_INFO_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["EXAM_INFO_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["EXAM_INFO_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.examInfoStatusData = res.data["EXAM_INFO_STATUS"];
        this.examInfoTypeData = res.data["EXAM_INFO_TYPE"];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
